
import { defineComponent } from "vue";

export default defineComponent({
  name: "UserTag",
  props: {
    id: String,
    userId: String,
    name: String,
  },
  methods: {
    removeSelected() {
      this.$emit("removeSelected", this.userId);
    },
  },
});
